module.exports = __webpack_public_path__ + "Пример_файла.xlsx";